// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"c8e46f6828a733821ef3","454":"b8ef4f249d80722ea087"}[chunkId] + ".js";
};